import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerCard } from '../models/customer-card';
import Env from '@ridango/core/env';

@Injectable()
export class CardsService {
    constructor(
        private http: HttpClient,
        @Inject('ENV') private env: Env
    ) {}

    getCustomerCards(): Observable<CustomerCard[]> {
        const url = `${this.env.CORE_API_URL}/customer/v3/region/${this.env.REGION_ID}/card`;
        return this.http.get<CustomerCard[]>(url);
    }

    blockCard(card: CustomerCard): Observable<void> {
        const payload = {
            card_nr: card?.cardNumber,
            region_id: this.env.REGION_ID,
            send_new: false
        };
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/related-cards/block`;
        return this.http.put<void>(url, payload);
    }

    unblockCard(card: CustomerCard): Observable<void> {
        const payload = {
            card_nr: card?.cardNumber,
            region_id: this.env.REGION_ID,
            send_new: false
        };
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/related-cards/unblock`;
        return this.http.put<void>(url, payload);
    }

    deleteRelatedCard(card: CustomerCard): Observable<void> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/related-cards/${card?.relatedCardId}`;
        return this.http.delete<void>(url);
    }
}
